var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main", [
    _c(
      "header",
      { staticClass: "container content-padding my-1" },
      [
        _c(
          "router-link",
          { staticClass: "navbar-brand", attrs: { to: "/", tag: "a" } },
          [
            _c("img", {
              staticClass: "logo",
              style: _vm.$mq.phone ? "padding: 0 1rem" : "",
              attrs: {
                src: "/static/img/main-logo.svg",
                height: "38",
                alt:
                  "BeNeat - บริการจองแม่บ้านทำความสะอาดออนไลน์ คุณภาพเชื่อถือได้"
              }
            })
          ]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "container content-padding my-1" }, [
      _c(
        "div",
        {
          staticClass:
            "d-flex flex-sm-row flex-column justify-content-center justify-content-sm-center"
        },
        [
          _vm.step === 1
            ? _c(
                "div",
                { staticClass: "mx-3 my-2" },
                [
                  _c("b-img-lazy", {
                    class: _vm.$mq.phone ? "img-fluid" : "img-default-size",
                    attrs: {
                      src:
                        "https://beneat.s3.ap-southeast-1.amazonaws.com/marketing_campaigns/agency-professional-register-promotion.png",
                      alt: ""
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { ref: "formInput", staticClass: "mx-3 my-2" },
            [
              _c(
                "b-form",
                {
                  attrs: { "data-vv-scope": "form-register-byagen" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.onSubmit.apply(null, arguments)
                    }
                  }
                },
                [
                  _vm.step == 1
                    ? [
                        _c("label", [_vm._v(" กรุณากรอกแบบฟอร์มการสมัคร")]),
                        _vm._v(" "),
                        _c("b-form-input", {
                          staticClass: "my-3",
                          attrs: {
                            id: "input-name",
                            type: "text",
                            placeholder: "ชื่อ นามสกุล",
                            required: ""
                          },
                          model: {
                            value: _vm.form.full_name,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "full_name", $$v)
                            },
                            expression: "form.full_name"
                          }
                        }),
                        _vm._v(" "),
                        _c("b-form-input", {
                          staticClass: "mt-3 mb-2",
                          attrs: {
                            id: "input-phone",
                            type: "text",
                            placeholder:
                              "เบอร์โทร (กรอกเฉพาะตัวเลขและพิมพ์ติดกัน)",
                            required: "",
                            state: _vm.nameState,
                            "aria-describedby": "input-live-feedback"
                          },
                          model: {
                            value: _vm.form.phone,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "phone", $$v)
                            },
                            expression: "form.phone"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "b-form-invalid-feedback",
                          { attrs: { id: "input-live-feedback" } },
                          [
                            _vm._v(
                              "\n              กรุณากรอกเบอร์โทรศัพท์\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("b-form-input", {
                          staticClass: "mt-3 mb-2",
                          attrs: {
                            id: "input-email",
                            type: "text",
                            placeholder: "อีเมล์ (โปรดระบุ)",
                            required: "",
                            state: _vm.nameState,
                            "aria-describedby": "input-live-feedback"
                          },
                          model: {
                            value: _vm.form.email,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "email", $$v)
                            },
                            expression: "form.email"
                          }
                        }),
                        _vm._v(" "),
                        _c("b-form-group", { staticClass: "mt-3" }, [
                          _c("label", [
                            _vm._v(" จังหวัดและเขต/อำเภอ ที่สะดวกให้บริการ")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row no-gutters" }, [
                            _c(
                              "div",
                              { staticClass: "col-6 mb-3 pr-1" },
                              [
                                _c("label", [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-danger font-weight-bold"
                                    },
                                    [_vm._v("*")]
                                  ),
                                  _vm._v(" จังหวัด")
                                ]),
                                _vm._v(" "),
                                _c("b-form-select", {
                                  attrs: {
                                    options: _vm.sortedProvinces,
                                    "value-field": "id",
                                    "text-field": "name_th",
                                    required: ""
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.changeAddressProvince(
                                        _vm.form.address_province_id
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.form.address_province_id,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "address_province_id",
                                        $$v
                                      )
                                    },
                                    expression: "form.address_province_id"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-6 mb-3 pl-1" },
                              [
                                _c("label", [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-danger font-weight-bold"
                                    },
                                    [_vm._v("*")]
                                  ),
                                  _vm._v(" เขต/อำเภอ")
                                ]),
                                _vm._v(" "),
                                _c("b-form-select", {
                                  attrs: {
                                    options: _vm.sortedDistricts,
                                    "value-field": "id",
                                    "text-field": "name_th",
                                    required: ""
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.changeDistrict(
                                        _vm.form.district_id
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.form.district_id,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "district_id", $$v)
                                    },
                                    expression: "form.district_id"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          [
                            _c("label", [
                              _c(
                                "span",
                                { staticClass: "text-danger font-weight-bold" },
                                [_vm._v("*")]
                              ),
                              _vm._v(" คุณแม่บ้านค้นหางานจากช่องทางใด")
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-form-checkbox-group",
                              {
                                attrs: {
                                  id: "checkbox-group-2",
                                  name: "flavour-2",
                                  stacked: ""
                                },
                                model: {
                                  value: _vm.form.media_channel,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "media_channel", $$v)
                                  },
                                  expression: "form.media_channel"
                                }
                              },
                              [
                                _c(
                                  "b-form-checkbox",
                                  {
                                    staticClass: "mb-3",
                                    attrs: { value: "Finnix" }
                                  },
                                  [
                                    _vm._v(
                                      "แอปฟินนิกซ์ (FINNIX) - มีโค้ดส่วนลด"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.form.media_channel.find(function(e) {
                                  return e == "Finnix"
                                })
                                  ? _c(
                                      "b-form-group",
                                      [
                                        _c("label", [_vm._v("กรอกโค้ดส่วนลด")]),
                                        _vm._v(" "),
                                        _c("b-form-input", {
                                          model: {
                                            value:
                                              _vm.form.media_channel_detail,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "media_channel_detail",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.media_channel_detail"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "b-form-checkbox",
                                  {
                                    staticClass: "my-3",
                                    attrs: { value: "google" }
                                  },
                                  [_vm._v("ค้นหาใน Google")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-checkbox",
                                  {
                                    staticClass: "my-3",
                                    attrs: { value: "Facebook" }
                                  },
                                  [_vm._v("ค้นหาใน Facebook")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-checkbox",
                                  {
                                    staticClass: "mt-3",
                                    attrs: { value: "Youtube" }
                                  },
                                  [_vm._v("ค้นหาใน Youtube")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-checkbox",
                                  {
                                    staticClass: "mt-3",
                                    attrs: { value: "Tiktok" }
                                  },
                                  [_vm._v("ค้นหาใน Tiktok")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "จังหวัดที่เปิดรับสมัคร : กรุงเทพฯ, นนทบุรี, ปทุมธานี, สมุทรปราการ, นครปฐม, สมุทรสาคร, เชียงใหม่, ชลบุรี"
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          [
                            _c(
                              "b-form-checkbox",
                              {
                                staticClass: "mt-3 mb-4",
                                attrs: {
                                  id: "checkbox-accepted",
                                  name: "checkbox-accepted",
                                  value: "1",
                                  "unchecked-value": "0"
                                },
                                model: {
                                  value: _vm.form.accepted_pdpa,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "accepted_pdpa", $$v)
                                  },
                                  expression: "form.accepted_pdpa"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                ยอมรับเงื่อนไขนโยบายคุ้มครองข้อมูลส่วนบุคคลและยินยอมให้เปิดเผย\n                ข้อมูลส่วนบุคคล "
                                ),
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      target: "_blank",
                                      download: "",
                                      href:
                                        "/static/pdf/เอกสารแสดงความยินยอมให้เปิดเผยข้อมูลส่วนบุคคล_beneat.pdf"
                                    }
                                  },
                                  [_vm._v("ดูเพิ่มเติม")]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    : _vm.step == 2
                    ? [
                        _c("div", { staticClass: "text-center" }, [
                          _c("h2", { staticStyle: { color: "red" } }, [
                            _vm._v(
                              "รหัสผู้สมัคร : BN" +
                                _vm._s(
                                  _vm.agencyProfessional ? _vm.codeAgency : ""
                                ) +
                                "\n                "
                            ),
                            _c("br"),
                            _vm._v(" "),
                            _vm.agencyProfessional
                              ? _c(
                                  "button",
                                  {
                                    directives: [
                                      {
                                        name: "clipboard",
                                        rawName: "v-clipboard:copy",
                                        value: "BN" + _vm.codeAgency,
                                        expression: "'BN'+codeAgency",
                                        arg: "copy"
                                      }
                                    ],
                                    staticClass:
                                      "h5 btn btn-outline-secondary mt-3",
                                    staticStyle: { cursor: "pointer" },
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.copiedCode(
                                          "BN" + _vm.codeAgency
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "i",
                                      { staticClass: "fa fa-clone mb-1" },
                                      [_vm._v("คัดลอกรหัส")]
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("h5", [
                            _vm._v(
                              "กรุณานำรหัสผู้สมัครที่ได้รับ แจ้งกลับในไลน์"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _vm.abTest == "ATest"
                          ? _c("div", { staticClass: "text-center mt-5" }, [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "https://lin.ee/R8qgKjG",
                                    target: "_blank"
                                  }
                                },
                                [
                                  _c("b-img-lazy", {
                                    class: _vm.$mq.phone ? "img-fluid" : "",
                                    staticStyle: { height: "100px" },
                                    attrs: {
                                      src:
                                        "/static/img/professional/semAgency/photo_click_add_line.jpeg"
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "row mt-3" }, [
                          _c("div", { staticClass: "col-12 col-md-6" }, [
                            _c(
                              "div",
                              [
                                _c("b-img-lazy", {
                                  class: _vm.$mq.phone
                                    ? "img-fluid"
                                    : "img-default-size",
                                  attrs: {
                                    src:
                                      "https://beneat.s3.ap-southeast-1.amazonaws.com/marketing_campaigns/agency-professional-register-promotion.png",
                                    alt: ""
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _vm.abTest == "ATest"
                            ? _c("div", { staticClass: "col-12 col-md-6" }, [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "https://lin.ee/R8qgKjG",
                                      target: "_blank"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.step = 1
                                      }
                                    }
                                  },
                                  [
                                    _c("b-img-lazy", {
                                      class: _vm.$mq.phone
                                        ? "img-fluid"
                                        : "img-default-size",
                                      attrs: {
                                        src:
                                          "/static/img/professional/semAgency/photo_add_line.jpeg"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _vm.abTest == "BTest"
                          ? _c("div", { staticClass: "text-center mt-3" }, [
                              _c("div", [
                                _c(
                                  "a",
                                  {
                                    staticClass: "btn",
                                    staticStyle: {
                                      "text-decoration": "underline"
                                    }
                                  },
                                  [_vm._v("ถ้ายังไม่ได้แอดไลน์")]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "https://lin.ee/R8qgKjG",
                                    target: "_blank"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.step = 1
                                    }
                                  }
                                },
                                [
                                  _c("b-img-lazy", {
                                    class: _vm.$mq.phone ? "img-fluid" : "",
                                    staticStyle: { height: "100px" },
                                    attrs: {
                                      src:
                                        "/static/img/professional/semAgency/photo_click_add_line.jpeg"
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("br")
                      ]
                    : _vm.step == 3
                    ? [
                        _c("div", { staticClass: "text-center" }, [
                          _c("h5", [
                            _vm._v(
                              "ลุ้นรับสิทธิพิเศษ ค่าอบรม ค่าสมัคร ค่าตรวจประวัติอาชญากรรม ฟรี !!"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-center mt-5" }, [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "https://lin.ee/R8qgKjG",
                                target: "_blank"
                              },
                              on: {
                                click: function($event) {
                                  _vm.step = 1
                                }
                              }
                            },
                            [
                              _c("b-img-lazy", {
                                class: _vm.$mq.phone ? "img-fluid" : "",
                                staticStyle: { height: "100px" },
                                attrs: {
                                  src:
                                    "/static/img/professional/semAgency/photo_click_add_line.jpeg"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", [
                            _c(
                              "a",
                              {
                                staticClass: "btn text-primary",
                                staticStyle: { "text-decoration": "underline" },
                                on: { click: _vm.AddedLine }
                              },
                              [_vm._v("แอดไลน์แล้ว กดที่นี่")]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row mt-3" }, [
                          _c("div", { staticClass: "col-12 col-md-6" }, [
                            _c(
                              "div",
                              [
                                _c("b-img-lazy", {
                                  class: _vm.$mq.phone
                                    ? "img-fluid"
                                    : "img-default-size",
                                  attrs: {
                                    src:
                                      "https://beneat.s3.ap-southeast-1.amazonaws.com/marketing_campaigns/agency-professional-register-promotion.png",
                                    alt: ""
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-md-6" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: "https://lin.ee/R8qgKjG",
                                  target: "_blank"
                                }
                              },
                              [
                                _c("b-img-lazy", {
                                  class: _vm.$mq.phone
                                    ? "img-fluid"
                                    : "img-default-size",
                                  attrs: {
                                    src:
                                      "/static/img/professional/semAgency/photo_add_line.jpeg"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("br")
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.step == 1
                    ? [
                        _c(
                          "b-button",
                          {
                            staticClass: "button-block mt-3",
                            attrs: {
                              disabled: !(
                                _vm.form.full_name &&
                                _vm.form.phone &&
                                _vm.form.accepted_pdpa == "1" &&
                                _vm.nameState == true
                              ),
                              type: "submit",
                              variant: "info"
                            }
                          },
                          [_vm._v("ส่งข้อมูล")]
                        )
                      ]
                    : _vm._e()
                ],
                2
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "section",
        {
          class: _vm.form.isHiddenChatButton,
          attrs: { id: "floating-icon-contacts" }
        },
        [
          _c(
            "div",
            {
              ref: "fab-agency-floating-button",
              staticClass: "fab-container",
              on: {
                mousemove: function($event) {
                  return _vm.onMouseMoveFloatingButton($event)
                },
                mouseleave: function($event) {
                  return _vm.onMouseLeaveFloatingButton($event)
                },
                click: function($event) {
                  return _vm.onClickFloatingButton($event)
                }
              }
            },
            [
              _c("div", { staticClass: "fab shadow" }, [
                _c("div", { staticClass: "fab-content" }, [
                  _c(
                    "span",
                    { staticClass: "material-icons" },
                    [
                      _c(
                        "transition",
                        { attrs: { name: "mode-fade", mode: "out-in" } },
                        [
                          !_vm.form.isActiveInMobile
                            ? _c("div", [
                                _c("img", {
                                  staticClass: "img-fluid rounded-circle",
                                  attrs: {
                                    src:
                                      "/static/img/floatingButton/call_center_crop_head.png",
                                    width: "80",
                                    alt: "",
                                    id: "img-call-center-crop"
                                  }
                                })
                              ])
                            : _c(
                                "div",
                                { staticClass: "circle-close-rotate" },
                                [
                                  _c("span", { staticClass: "icon-cross" }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "visually-hidden" },
                                    [_vm._v("Close")]
                                  )
                                ]
                              )
                        ]
                      )
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _vm._m(2)
            ]
          )
        ]
      )
    ]),
    _vm._v(" "),
    _vm.step == 1
      ? _c("section", [
          _c("section", [
            _c("div", { staticClass: "section-apply-professionals" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-10 offset-md-1" }, [
                  _c("h2", { staticClass: "text-center" }, [
                    _vm._v(_vm._s(_vm.$t("message.apply.what_is_beneat_title")))
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-left" }, [
                    _vm._v(
                      _vm._s(_vm.$t("message.apply.what_is_beneat_detail"))
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-left" }, [
                    _vm._v(
                      "\n              เราเป็นบริษัท Startup ที่ได้รับการสนับสนุน จากกระทรวงวิทยศาสตร์และเทคโนโลยี เพื่อการพัฒนาระบบการรับงานทำความสะอาดแบบพาร์ทไทม์ ผ่านเทคโนโลยี Application เพื่อให้คุณแม่บ้าน สามารถทำงานพาร์ทไทม์ได้ อย่างสะดวก รวดเร็ว และ ปลอดภัย ในยุคไทยแลนด์ 4.0\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _vm._m(3),
                  _vm._v(" "),
                  _c("p", { staticClass: "mt-3 text-left" }, [
                    _vm._v(
                      "\n              ท่านรัฐมนตรีว่าการกระทรวงวิทยาศาตร์และเทคโนโลยี (ดร.สุวิทย์ เมษินทรีย์) เข้าเยี่ยมเยือนบริษัท และ ให้กำลังใจคุณแม่บ้าน\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "mt-3 text-left",
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("message.apply.sub_title"))
                    }
                  }),
                  _vm._v(" "),
                  _vm._m(4),
                  _vm._v(" "),
                  _vm._m(5)
                ])
              ]),
              _vm._v(" "),
              _vm._m(6)
            ])
          ]),
          _vm._v(" "),
          _c("section", { staticClass: "content-padding" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("h2", { staticClass: "text-center" }, [
                  _vm._v(_vm._s(_vm.$t("message.apply.why_work_with_beneat")))
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mt-4" }, [
              _vm._m(7),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-3 col-md-3 text-center" }, [
                _c("i", {
                  staticClass: "fal fa-clock",
                  staticStyle: { "font-size": "60px", color: "#1FBCD2" }
                }),
                _vm._v(" "),
                _c("h3", { staticClass: "mt-3" }, [
                  _vm._v(_vm._s(_vm.$t("message.apply.why_benefit_title01")))
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(_vm._s(_vm.$t("message.apply.why_benefit_detail01")))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-3 col-md-3 text-center" }, [
                _c("img", {
                  attrs: { src: "/static/img/protect.svg", width: "60" }
                }),
                _vm._v(" "),
                _c("h3", { staticClass: "mt-3" }, [
                  _vm._v(_vm._s(_vm.$t("message.apply.why_benefit_title02")))
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(_vm._s(_vm.$t("message.apply.why_benefit_detail02")))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-3 col-md-3 text-center" }, [
                _c("img", {
                  attrs: { src: "/static/img/community.svg", width: "60" }
                }),
                _vm._v(" "),
                _c("h3", { staticClass: "mt-3" }, [
                  _vm._v(_vm._s(_vm.$t("message.apply.why_benefit_title03")))
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(_vm._s(_vm.$t("message.apply.why_benefit_detail03")))
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("section", { staticClass: "section-apply-professionals" }, [
            _c("div", { staticClass: "row" }, [
              _c("h2", [_vm._v(_vm._s(_vm.$t("message.apply.requirements")))]),
              _vm._v(" "),
              _c("ul", { staticClass: "maininfo-list text-left" }, [
                _c("li", [
                  _vm._v(_vm._s(_vm.$t("message.apply.requirements01")))
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(_vm._s(_vm.$t("message.apply.requirements02")))
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(_vm._s(_vm.$t("message.apply.requirements03")))
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(_vm._s(_vm.$t("message.apply.requirements04")))
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(_vm._s(_vm.$t("message.apply.requirements05")))
                ])
              ])
            ]),
            _vm._v(" "),
            _vm._m(8),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-6" }, [
                _c("div", { staticClass: "card" }, [
                  _c("div", { staticClass: "card-body text-center" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-warning btn-block",
                        on: { click: _vm.focusInput }
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t("message.apply.register")) +
                            "\n              "
                        )
                      ]
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mb-4" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("h4", [
                  _vm._v(_vm._s(_vm.$t("message.apply.contact_data00")))
                ]),
                _vm._v(" "),
                _c("h4", [
                  _vm._v(_vm._s(_vm.$t("message.apply.contact_data01")))
                ]),
                _vm._v(" "),
                _c("h4", [
                  _vm._v(_vm._s(_vm.$t("message.apply.contact_data03")))
                ])
              ])
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sub-button shadow" }, [
      _c("a", { attrs: { href: "tel:02-113-1138", target: "_blank" } }, [
        _c("span", { staticClass: "item-icons" }, [
          _c("img", {
            staticClass: "img-fluid rounded-circle",
            attrs: {
              src: "/static/img/floatingButton/telephone-call.png",
              "data-platform": "telephone",
              width: "80"
            }
          })
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sub-button shadow" }, [
      _c("a", { attrs: { href: "https://lin.ee/sA89db3", target: "_blank" } }, [
        _c("span", { staticClass: "item-icons" }, [
          _c("img", {
            staticClass: "img-fluid rounded-circle",
            attrs: {
              src: "/static/img/floatingButton/line.png",
              "data-platform": "line",
              width: "80"
            }
          })
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sub-button shadow" }, [
      _c(
        "a",
        { attrs: { href: "https://www.m.me/BeNeatCleaner", target: "_blank" } },
        [
          _c("span", { staticClass: "item-icons" }, [
            _c("img", {
              staticClass: "img-fluid rounded-circle",
              attrs: {
                src: "/static/img/floatingButton/messenger.png",
                "data-platform": "messenger",
                width: "80"
              }
            })
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-6" }, [
        _c("img", {
          staticClass: "img-fluid",
          attrs: {
            src: "/static/img/apply-news01.jpg",
            alt: "ภาพบรรยากาศการทำงานของแม่บ้าน BeNeat"
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-6 col-md-6 mt-2 mt-md-0" }, [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: "/static/img/apply-news02.jpg", alt: "" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "embed-responsive embed-responsive-16by9" },
      [
        _c("iframe", {
          attrs: {
            width: "560",
            height: "315",
            src: "https://www.youtube.com/embed/YaHw1mGL_kk",
            frameborder: "0",
            allow: "autoplay; encrypted-media",
            allowfullscreen: ""
          }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "embed-responsive embed-responsive-16by9 mt-5" },
      [
        _c("iframe", {
          attrs: {
            width: "560",
            height: "315",
            src: "https://www.youtube.com/embed/tQw3LCKszs8",
            frameborder: "0",
            allow: "autoplay; encrypted-media",
            allowfullscreen: ""
          }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("div", { staticClass: "mt-4 text-left" }, [
          _vm._v(
            "\n              BeNeat Academy คือ ศูนย์ฝึกอบรมคุณแม่บ้านที่มีมาตรฐาน โดย คุณแม่บ้านทุกท่านในระบบ จะได้รับการฝึกสอนทั้งทาง ทฤษฎี และ ปฎิบัติโดยผู้เชี่ยวชาญของบีนีท ซึ่งเป็นหลักสูตรที่บีนีทมีการออกแบบมาอย่างดี และ เป็นลิขสิทธิ์เฉพาะ ของบีนีท\n            "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mt-4 text-left" }, [
          _vm._v(
            "\n              ในศูนย์ฝึกอบรมจะประกอบด้วย สิ่งอำนวยความสะดวกทันสมัยต่างๆ ที่จำลองมาจากสภาพหน้างานจริงๆ ไม่ว่าจะเป็นห้องพักลักษณะ บ้าน, condo , สำนักงาน และ โรงแรม ซึ่งคุณแม่บ้านจะได้รับการฝึกฝนให้สามารถรับมือกับ ลักษณะงานที่หลากหลายเกือบทุกประเภท และสร้างความมั่นใจให้กับคุณแม่บ้านก่อนเข้าไปทำงานจริง\n            "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-3 col-md-3 text-center" }, [
      _c("img", { attrs: { src: "/static/img/wallet.svg", width: "60" } }),
      _vm._v(" "),
      _c("h3", { staticClass: "mt-3" }, [_vm._v("รายได้ดี")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "ผู้ให้บริการในระบบส่วนใหญ๋ได้รับรายได้เฉลี่ยเดือนละ 20,000-40,000 บาท (ขึ้นอยู่กับความขยันและความตั้งใจทำงาน)"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mt-3" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h4", [_vm._v("สมัครผู้ให้บริการ")])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66d4e762", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66d4e762","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/agencyProfessionalRegister/index.vue
// module id = 2388
// module chunks = 0